<template>
    <div class="VolunteersListPage CatalogPage">
        <div class="container">
          <SearchForm class="row search-component" :result="params.search"  v-if="$mqAbove('MOBILE')" />
          <div class="filters" v-if="$mqAbove('MOBILE')">
                <div class="row mb-3">
                    <div class="col d-3 md-4">
                        <ASelect static-label
                                 label=" "
                                 display="title"
                                 @change="setFilter"
                                 multiple
                                 :placeholder="params.filters.category.placeholder"
                                 :options="params.filters.category.options"
                                 v-model="fieldData.category"
                        >
                            <template #item="item">
                                <div class="flex v-center">
                                    <a-checkbox :label="item.title" v-model="item.selected"/>
                                </div>
                            </template>
                        </ASelect>
                    </div>
                </div>
                <div class="row">
                    <div class="col d6 selectedFilters">
                        <ABadge v-for="bage in params.filters.bages">
                            <div class="flex v-center">
                              {{ bage.title }}
                                <i class="close" @click="removeFilter(bage.id)"></i>
                            </div>
                        </ABadge>
                    </div>
                </div>
            </div>
          <div class="filters--mobile" v-else>
              <div class="filters--mobileHeading">
                  <span>{{params.messages.filterMobileBtn}}</span>
                  <img src="/local/templates/main/img/icons/filters.svg" alt="" @click="toggleMobileFilters(true)">
              </div>
              <div class="filtersMobileMenu" :class="{'filtersMobileMenu--opened': filtersOpened}">
                  <div class="header__actions-mob flex v-center menu-toggle">
                      <ABtn @click="toggleMobileFilters(false)" :class="{active: true}">
                          <template #content>
                              <div class="icon">
                                  <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M20 0H0V2H20V0Z"></path>
                                  </svg>
                                  <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M20 0H0V2H20V0Z"></path>
                                  </svg>
                                  <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M20 0H0V2H20V0Z"></path>
                                  </svg>
                              </div>
                          </template>
                      </ABtn>
                  </div>

                  <ASelect static-label
                           label=" "
                           display="title"
                           @change="setFilter"
                           :placeholder="params.filters.category.placeholder"
                           :options="params.filters.category.options"
                           v-model="fieldData.category"
                  >
                      <template #item="{title}">{{ title }}</template>
                  </ASelect>
              </div>
          </div>
          <div class="row mb-4">
              <div class="col d12">


                  <VolunteersTable :list="data.list.items" :banner="data.banner" />

                <div class="paginationContainer" v-if="data.list?.pagen">
                  <APagination
                      :perPage="1"
                      :records="data.list?.pagen?.countPage"
                      :currentPage="data.list?.pagen?.currentPage"
                      :options="{chunk: 5, edgeNavigation: false, linkTemplate:data.list.pagen?.linkTemplate, hideCount: true, texts: { }}"
                      :show-more="data.list.pagen?.showMore"
                      :messages="data?.messages"
                      @showMore="addMore"
                  />
                </div>
              </div>
          </div>



            <AppSection>
                <template #body>
                    <InfoCard :img="params.textBlock.img">
                    <h2>{{params.textBlock.title}}</h2>
                        <ul v-if="params.textBlock.items">
                            <li v-for="item in params.textBlock.items">

                                <strong>{{item.title}}</strong><br>
                              {{item.text}}
                            </li>
                        </ul>
                    </InfoCard>
                </template>
            </AppSection>

            <section class="articles">
                <ArticlesSection :params="articles"/>
            </section>
        </div>
    </div>
</template>

<script>
import {ref, computed, provide} from 'vue';
import Toggle from '@vueform/toggle'
import useFilterControls from "~/composables/useFilterControls";
import {ABtn, ABadge, ASelect, ADatePicker, AExpand, ACheckbox, useAProgressBar} from '~/components/ui'
import VolonterCard from "~/components/cards/VolonterCard";
import InfoCard from "~/components/cards/InfoCard";
import HelpSection from "../../components/sections/HelpSection";
import TopVolontersSection from "../../components/sections/TopVolontersSection";
import ArticlesSection from "../../components/sections/ArticlesSection";
import Subscribe from "../../components/sections/Subscribe";
import ADropdown from "../../components/ui/ADropdown";
import APagination from "../../components/ui/APagination";
import StoryCard from "../../components/cards/StoryCard";
import VolunteersTable from "../../components/volunteers-table/VolunteersTable";
import AppSection from "../../components/AppSection";
import SearchForm from "../..//components/Search/SearchForm.vue";
import {send} from "../../services/api";

export default {
    name: "VolunteersRatingPageContainer",
    props: ['params'],
    components: {
        SearchForm,
        AppSection,
        VolunteersTable,
        StoryCard,
        APagination,
        ADropdown,
        Subscribe,
        ArticlesSection,
        TopVolontersSection,
        HelpSection,
        ABtn, ABadge, ASelect, ADatePicker, VolonterCard, InfoCard, AExpand, ACheckbox, Toggle
    },
    setup(props) {
        provide('translates', props.params.messages)

        const {filtersOpened, toggleMobileFilters} = useFilterControls()
        const fieldData = ref({pro: false,category:[]});
        for (let index in props.params.filters?.category?.options) {
          if(props.params.filters?.category?.options[index].selected) {
            fieldData.value?.category?.push(props.params.filters.category.options[index]);
          }
        }
        const data = ref(props.params);
        const sortOptions = computed(() => {
            return [{name: 'Рейтингу', value: 'rating'}, {name: 'Отзывам', value: 'reviews'}, {
                name: 'Задачам',
                value: 'tasks'
            }]
        })

        const sort = ref(sortOptions.value[0].value);

        const setFilter = () => {
          let cat = [];
          for(let index in fieldData.value.category) {
            if(fieldData.value.category[index].value!=undefined) {
              cat.push(fieldData.value.category[index].value);
            }
          }
          cat = cat.join('-or-');
          if(data.timer) {
            clearTimeout(data.timer);
          }
          data.timer = setTimeout(()=>{
            location.href = props.params.filters.linkTemplate.replace('#VARIABLE#', cat);
          },1500);
        }


        const articles = ref(props.params.articles);


        const removeFilter = (code) => {
          for (let index in fieldData.value.category) {
            if(fieldData.value.category[index].value==code) {
              fieldData.value.category.splice(index, 1);
            }
          }
          setFilter();
        }
        const progress = useAProgressBar();
        const addMore = async () => {
          progress.show();
          //responseKey
          await send(data.value.list?.pagen.showMore, {method: "GET"}, {}).then((response) => {
            data.value.list.pagen= response[data.value.responseKey].list.pagen;
            for(let index in response[data.value.responseKey].list.items) {
              if(response[data.value.responseKey].list.items[index].name!=undefined) {
                data.value.list.items.push(response[data.value.responseKey].list.items[index]);
              }
            }
            progress.hide();
          });
        }


        return {
            filtersOpened,
            setFilter,
            data,
            sortOptions,
            toggleMobileFilters,
            fieldData,
            articles,
            sort,
            addMore,
            removeFilter
        }
    }
}
</script>

<style scoped lang="scss">
.VolunteersListPage {
  .search-component {
    margin-top: -80px;
    position:relative;
  }

    //@todo to component
    .toggleBtn {
        display: flex;
        gap: 10px;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
    }

    .dropdownFilters {
        display: flex;
        justify-content: flex-end;
    }
}

.info {
    padding-top: 140px;
}

::v-deep .section-help.bg {
    background: #fff;
}

.paginationContainer {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    .showMore {
        max-width: 205px;

        @include mobile {
            max-width: 100%;
        }
    }

    ::v-deep .APagination {
        @include mobile {
            display: none;
        }
    }
}
</style>

<style>
:root {
    --toggle-width: 2.5rem;
    --toggle-border: 0;
    --toggle-bg-on: #6367A7
}
.search-component .search__response {
    top: calc(100% - 14px);

}
</style>

<style src="@vueform/toggle/themes/default.css"></style>
